import { StorageService } from './StorageService';
import { Card } from '@/models/Card';
import { Player } from '@/models/Player';
import { MyDetails } from '@/models/MyPlayerDetails';

export enum GameState {
  connecting = 0,
  connected = 1,
  joining = 2,
  voting = 10,
  results = 20
}

export class RoomDataStore {
  gameState: GameState;
  gameResetEnabled: boolean;

  cards: Card[] = [
    new Card('_0', '0'),
    new Card('_1/2', '1/2'),
    new Card('_1', '1'),
    new Card('_2', '2'),
    new Card('_3', '3'),
    new Card('_5', '5'),
    new Card('_8', '8'),
    new Card('_13', '13'),
    new Card('_20', '20'),
    new Card('_40', '40'),
    new Card('_question', '?'),
    new Card('_coffee', '☕')
  ];
  players: Player[] = [];

  selectedCard: Card | null = null;
  myDetails: MyDetails | null;
  theme: string | null;

  constructor(private readonly storageService: StorageService) {
    this.gameState = GameState.voting;
    this.gameResetEnabled = false;
    this.myDetails = this.storageService.getPlayerDetails() as MyDetails;
    this.theme = this.storageService.getTheme();
  }

  public setGameState(state: GameState) {
    this.gameState = state;
  }

  public setPlayerDetails(myDetails: MyDetails) {
    this.myDetails = myDetails;
    this.storageService.updatePlayerDetails(myDetails);
  }

  public setTheme(theme: string) {
    this.theme = theme;
    this.storageService.updateTheme(theme);
  }

  public getPlayerByConnectionId(connectionId: string) {
    return this.players.find(p => p.connectionId === connectionId);
  }

  public addPlayer(player: Player) {
    if (this.players.every(p => p.connectionId != player.connectionId)) this.players.push(player);
  }

  public isMyPlayer(player: Player): boolean {
    return this.myDetails?.name == player.name;
  }

  public removePlayer(player: Player) {
    const playerIndex = this.players.indexOf(player);
    if (playerIndex > -1) this.players.splice(playerIndex, 1);
  }

  public getCardById(id: string) {
    return this.cards.find(c => c.id === id);
  }
  public selectCard(card: Card) {
    this.selectedCard = card;
  }
  public clearCard() {
    this.selectedCard = null;
  }

  public startResetCooldown() {
    setTimeout(() => {
      this.gameResetEnabled = true;
    }, 2000);
  }

  public resetGame() {
    this.clearCard();
    this.players.forEach(player => player.clear());
    this.setGameState(GameState.voting);
  }

  public clearResetCooldown() {
    this.gameResetEnabled = false;
  }
}
